import { TabPanel } from '@headlessui/react';
import FormattedCurrency from '@otovo/shared/components/Currency/FormattedCurrency';
import m from '@otovo/shared/components/PurchaseModelComparison/messages';
import Button from '@otovo/shared/rainbow/Button/Button';
import cx from 'classnames';
import { FormattedMessage as T } from 'react-intl';
import SellingPointsLeasing from './SellingPointsLeasing';

type Props = { leasingLandingPageUrl: string; startingPriceLeasing: number };

const Leasing = ({ leasingLandingPageUrl, startingPriceLeasing }: Props) => {
  return (
    <TabPanel className="grid grid-cols-1 gap-10 md:grid-cols-2">
      <SellingPointsLeasing />
      <div className="flex flex-col space-y-14 text-grey-90">
        <div className="w-full">
          <p className="mb-3 text-base text-grey-60">
            <T {...m.leasingIntroduction} />
          </p>
          {leasingLandingPageUrl && (
            <a
              href={leasingLandingPageUrl}
              className={cx(
                'text-digital',
                'hover:underline hover:underline-offset-4 focus:outline-offset-4 focus:outline-grey-90',
              )}
            >
              <T {...m.learnMoreAboutLeasing} />
            </a>
          )}
        </div>
        <div className="w-full">
          <p className="mb-10 tracking-tight text-grey-60 sm:text-2xl">
            <T {...m.fromPrice} />{' '}
            <span className="text-[55px] font-semibold text-grey-90">
              <FormattedCurrency value={startingPriceLeasing} />
            </span>
            <T {...m.perMonthSymbol} />
          </p>
          <Button
            className="w-full text-lg"
            onClick={() => {
              window.scroll({
                top: 0,
                behavior: 'smooth',
              });
            }}
          >
            <T {...m.scrollToTopButton} />
          </Button>
        </div>
      </div>
    </TabPanel>
  );
};

export default Leasing;
